import { FieldPath } from 'react-hook-form';
import { FormSchema } from './form-schema';

export type DataType = 'fta' | 'rsa';

const DATA_TYPES: DataType[] = ['fta', 'rsa'];

type DimensionHeaderPaths = {
  fta: FieldPath<FormSchema>;
  rsa: FieldPath<FormSchema>;
};

const fieldPath = (
  dataType: DataType,
  dimensionSlug: string
): FieldPath<FormSchema> =>
  `dimensions.${dimensionSlug as keyof FormSchema['dimensions']}.${dataType === 'fta' ? 'visitsTableHeader' : 'salesTableHeader'}`;

export const getFieldPath = (dimensionSlug: string): FieldPath<FormSchema> =>
  `dimensions.${dimensionSlug as keyof FormSchema['dimensions']}.checkbox`;

export const getCustomFieldKeys = (
  dimensionSlug: string
): DimensionHeaderPaths => {
  // Consider adding some more type checks here to avoid coercing string
  // to a more specific type

  const headersByDataType = DATA_TYPES.reduce<DimensionHeaderPaths>(
    (acc, dataType) => {
      acc[dataType] = fieldPath(dataType, dimensionSlug);
      return acc;
    },
    {} as DimensionHeaderPaths
  );

  return headersByDataType;
};
